import React from 'react';
import { Globe } from 'lucide-react';

const LANGUAGES = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
];

function LanguageSelector({ selectedLanguage, onLanguageChange, disabled = false }) {
    return (
        <div className="relative">
            <select
                value={selectedLanguage}
                onChange={(e) => onLanguageChange(e.target.value)}
                disabled={disabled}
                className={`
                    appearance-none bg-white border border-stone-200 rounded-lg px-3 py-1.5 pr-8 text-xs text-stone-700
                    focus:outline-none focus:ring-1 focus:ring-stone-300
                    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-stone-50'}
                    transition-colors
                `}
            >
                {LANGUAGES.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                        {lang.flag} {lang.name}
                    </option>
                ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <Globe className="w-3.5 h-3.5 text-stone-400" />
            </div>
        </div>
    );
}

export default LanguageSelector;
